export default __webpack_public_path__ + "static/consumer-interscroller-1c55615d2bf762efe30ba07a2fdfdb1f.gif";